// src/components/DashboardWidget.js
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// This component will take an icon, title, a total count, 
// and an array of detailed stats.
function DashboardWidget({ icon, title, totalCount, stats = [], linkTo, onClick }) {

  // Helper to get text color based on the label
  const getTextColor = (label) => {
    switch (label.toLowerCase()) {
      case 'active':
      case 'assigned':
      case 'completed':
        return 'text-success';
      case 'pending':
        return 'text-warning';
      case 'deactivated':
      case 'unassigned':
      case 'failed':
        return 'text-danger';
      case 'new':
        return 'text-primary';
      default:
        return 'text-muted';
    }
  };

  // Determine if this is a Link or a Button-like card
  const CardComponent = linkTo ? Link : 'div';
  const cardProps = linkTo ? { to: linkTo } : { onClick: onClick, style: { cursor: 'pointer' } };

  return (
    <Col>
      <Card as={CardComponent}
        {...cardProps}
        className="text-decoration-none shadow-sm h-100 border-0">
        <Card.Body className="p-3">
          <Row className="g-0 align-items-center">
            {/* Left Icon */}
            <Col xs={3} className="d-flex justify-content-center align-items-center text-secondary">
              {icon}
            </Col>

            {/* Right Content */}
            <Col xs={9} className="ps-3">
              <h6 className="text-uppercase text-secondary fw-bold" style={{ fontSize: '0.8rem' }}>
                {title}
              </h6>

              <div className="d-flex justify-content-between align-items-center">
                {/* Total Count */}
                <h2 className="fw-bold text-dark mb-0">{totalCount}</h2>

                {/* Stats List */}
                <div className="text-left" style={{ fontSize: '0.85rem' }}>
                  {stats.map(stat => (
                    <div key={stat.label} className={`fw-bold ${getTextColor(stat.label)}`}>
                      {stat.count} {stat.label}
                    </div>
                  ))}
                </div>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default DashboardWidget;